// Module
var code = "<span></span> ";
// Exports
export default code;